import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projectAvatarAlien: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-alien',
		defaultMessage: 'One-eyed alien in spaceship',
		description: 'Accessible name for project alien avatar.',
	},
	projectAvatarParrot: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-parrot',
		defaultMessage: 'Smiling bird with yellow beak',
		description: 'Accessible name for project parrot avatar.',
	},
	projectAvatarCloud: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-cloud',
		defaultMessage: 'Happy cloud',
		description: 'Accessible name for project cloud avatar.',
	},
	projectAvatarDisc: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-disc',
		defaultMessage: 'Vinyl record',
		description: 'Accessible name for project disc avatar.',
	},
	projectAvatarCode: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-code',
		defaultMessage: 'Computer browser',
		description: 'Accessible name for project code avatar.',
	},
	projectAvatarCoffee: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-coffee',
		defaultMessage: 'Coffee cup',
		description: 'Accessible name for project coffee avatar.',
	},
	projectAvatarDesign: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-design',
		defaultMessage: 'Painting of landscape resting on easel',
		description: 'Accessible name for project design avatar.',
	},
	projectAvatarDrill: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-drill',
		defaultMessage: 'Yellow electric drill',
		description: 'Accessible name for project drill avatar.',
	},
	projectAvatarFood: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-food',
		defaultMessage: 'Hot dog with mustard',
		description: 'Accessible name for project food avatar.',
	},
	projectAvatarKoala: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-koala',
		defaultMessage: 'Smiling koala eating leaf',
		description: 'Accessible name for project koala avatar.',
	},
	projectAvatarMobile: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-mobile',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Smartphone with smiley face',
		description: 'Accessible name for project mobile avatar.',
	},
	projectAvatarMoney: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-money',
		defaultMessage: 'Wallet with money sticking out',
		description: 'Accessible name for project money avatar.',
	},
	projectAvatarWebsite: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-website',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Computer browser with cursor in centre',
		description: 'Accessible name for project website avatar.',
	},
	projectAvatarNature: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-nature',
		defaultMessage: 'Snow-capped mountains with sun behind',
		description: 'Accessible name for project nature avatar.',
	},
	projectAvatarNotes: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-notes',
		defaultMessage: 'Notebook with pencil',
		description: 'Accessible name for project notes avatar.',
	},
	projectAvatarPlane: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-plane',
		defaultMessage: 'Airplane flying skyward',
		description: 'Accessible name for project plane avatar.',
	},
	projectAvatarPower: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-power',
		defaultMessage: 'Purple and orange battery with plus symbol',
		description: 'Accessible name for project power avatar.',
	},
	projectAvatarFlag: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-flag',
		defaultMessage: 'Red flag on pole',
		description: 'Accessible name for project flag avatar.',
	},
	projectAvatarRefresh: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-refresh',
		defaultMessage: 'Two circular arrows representing refresh icon',
		description: 'Accessible name for project refresh avatar.',
	},
	projectAvatarRocket: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-rocket',
		defaultMessage: 'Rocket flying through space',
		description: 'Accessible name for project rocket avatar.',
	},
	projectAvatarScience: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-science',
		defaultMessage: 'Science bottle full of bubbling red liquid',
		description: 'Accessible name for project science avatar.',
	},
	projectAvatarSettings: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-settings',
		defaultMessage: 'Settings control panel with vertical sliders',
		description: 'Accessible name for project settings avatar.',
	},
	projectAvatarSpanner: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-spanner',
		defaultMessage: 'Silver wrench',
		description: 'Accessible name for project spanner avatar.',
	},
	projectAvatarStorm: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-storm',
		defaultMessage: 'Storm cloud with rain and lightning',
		description: 'Accessible name for project storm avatar.',
	},
	projectAvatarSupport: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-support',
		defaultMessage: 'Red and white life buoy on blue background',
		description: 'Accessible name for project support avatar.',
	},
	projectAvatarYeti: {
		id: 'project-details.avatar-picker-dialog.accessible-avatar-names.project-avatar-yeti',
		defaultMessage: 'Frowning abominable snowman',
		description: 'Accessible name for project yeti avatar.',
	},
});
